const base_url = process.env.REACT_APP_API_HOST;

function getUserId(){
    return localStorage.getItem('userToken') || '';
}

export function GET(url) {
    return fetch(base_url + url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'X-User-ID': getUserId()
        }
    })
    .then(response => response.json())
    .catch(err => console.error('API call error:', err));
}

export function POST(url, body) {

    console.log('POST URL:', base_url + url);
    console.log('POST Body:', body);

    return fetch(base_url + url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'X-User-ID': getUserId()
        },
        body: body ? JSON.stringify(body) : null
    })
    .then(response => response.json())
    .then(data => {
        console.log('Response:', JSON.stringify(data));
        return data;
    })
    .catch(err => console.error('API call error:', err));
}